/**
 * Completion Modal
 *
 * Final step of onboarding - account creation confirmation
 * Figma: Property 1=Variant7 (Node: 1015:30988)
 * Dimensions: 636×471px
 */
"use client";

import { modalSpacing } from "@/styles/design-tokens";

import { BasicModalShell } from "./BasicModalShell";
import { ModalPrimaryButton } from "./ModalPrimaryButton";

interface CompletionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinueShopping: () => void;
  userEmail?: string;
}

export function CompletionModal({
  isOpen,
  onClose,
  onContinueShopping,
  userEmail = "",
}: CompletionModalProps) {
  return (
    <BasicModalShell
      isOpen={isOpen}
      onClose={onClose}
      closeOnBackdropClick={false}
      panelClassName="sm:min-h-[471px]"
      closeButtonClassName="sm:top-[29px]"
      scrollClassName="flex items-center justify-center"
    >
      <div className="flex w-full justify-center px-8 py-16 sm:py-0">
        {/* Content Container - Centered */}
        <div
          className="flex flex-col items-center text-center"
          style={{
            width: modalSpacing.signInContentWidth,
            maxWidth: "100%",
            gap: "35px",
          }}
        >
          {/* Title and Message */}
          <div className="flex flex-col items-center" style={{ gap: "24px" }}>
            <h2 className="text-title text-ink">Account Created</h2>
            <p className="text-caption text-ink-secondary text-center">
              Welcome to Cosimo! A confirmation email has been sent to {userEmail || "[your email]"}
              .
            </p>
          </div>

          {/* Continue Shopping Button */}
          <ModalPrimaryButton onClick={onContinueShopping}>Continue Shopping</ModalPrimaryButton>
        </div>
      </div>
    </BasicModalShell>
  );
}
